<template>
  <el-cascader
    v-bind="$attrs"
    v-model="innerValue"
    :options="options"
    clearable
    filterable
  />
</template>

<script>
import regions from "./region.js";

export default {
  name: "AreaSelector",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // 控制级联层级：3=省市区（默认），2=省市
    level: {
      type: Number,
      default: 3,
    },
    // 已被其他分区占用、需要置灰的城市 regionId 列表
    disabledCityIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      regions,
    };
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    options() {
      const disabledSet = new Set(this.disabledCityIds);
      return regions.map((prov) => {
        const cities = (prov.children || []).map((city) => {
          const cityNode = {
            value: city.regionId,
            label: city.regionName,
            disabled: disabledSet.has(city.regionId),
          };
          if (this.level >= 3) {
            cityNode.children = (city.children || []).map((district) => ({
              value: district.regionId,
              label: district.regionName,
            }));
          }
          return cityNode;
        });
        return {
          value: prov.regionId,
          label: prov.regionName,
          children: cities,
        };
      });
    },
  },
};
</script>
